var map = {
	"./accessibility-button.svg": 59530,
	"./accessibility.svg": 93989,
	"./arrow-top.svg": 52760,
	"./blob.svg": 60766,
	"./calendar.svg": 90885,
	"./control-next-hover.svg": 22065,
	"./control-next.svg": 46972,
	"./control-pause-hover.svg": 41074,
	"./control-pause.svg": 20475,
	"./control-play-hover.svg": 19152,
	"./control-play.svg": 84917,
	"./control-previous-hover.svg": 96857,
	"./control-previous.svg": 27860,
	"./dialog.svg": 42395,
	"./document.svg": 46300,
	"./documents.svg": 33847,
	"./email-blue.svg": 83370,
	"./email.svg": 16941,
	"./external-link.svg": 62955,
	"./facebook.svg": 3155,
	"./fb-white.svg": 88083,
	"./fb.svg": 39347,
	"./hands.svg": 28971,
	"./heading-shape.svg": 2255,
	"./ig-white.svg": 13067,
	"./ig.svg": 20347,
	"./instagram.svg": 72881,
	"./knowledge.svg": 25265,
	"./map-marker.png": 86381,
	"./map-marker.svg": 79090,
	"./money.svg": 18277,
	"./organisation-placeholder.svg": 12577,
	"./phone-blue.svg": 55810,
	"./phone.svg": 66005,
	"./play-video.svg": 20611,
	"./presentation.svg": 45707,
	"./tick.svg": 79132,
	"./trophy.svg": 70933,
	"./user-placeholder.svg": 59862,
	"./video-play-arrow.svg": 51343,
	"./white-arrow-full-big.svg": 79009,
	"./white-arrow-full.svg": 40308,
	"./www-blue.svg": 27885,
	"./www.svg": 54228,
	"./x.svg": 18989,
	"./youtube.svg": 99650,
	"./yt-white.svg": 13384,
	"./yt.svg": 99144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25853;